import { render, staticRenderFns } from "./BillableItem.vue?vue&type=template&id=cf3687a4&scoped=true"
import script from "./BillableItem.vue?vue&type=script&lang=js"
export * from "./BillableItem.vue?vue&type=script&lang=js"
import style0 from "./BillableItem.vue?vue&type=style&index=0&id=cf3687a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3687a4",
  null
  
)

export default component.exports